import React from 'react';
import ReactDOM from 'react-dom/client';

import { CareersPage } from './CareersPage';
import type { CareersPageData } from './types';

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: CareersPageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('careers-root');
if (!container) { throw new Error('Missing #careers-root element'); }
const root = ReactDOM.createRoot(container);
root.render(React.createElement(CareersPage, pageData));

if (module.hot) { module.hot.accept(); }
